import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import Client from 'shopify-buy';
import 'whatwg-fetch'; // for ie11
import River from '../../shared/River';
import ShopifyCard from './ShopifyCard';
import Button from '../../shared/Button';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: {
      SHOPIFY: { SHOP_ALL, GEAR_UP }
    }
  }
} = StringConstantsMixin;

const slickSettings = { slidesToShow: 5 };

const ShopifyPreview = ({ shopifyToken, shopifyCollectionId }) => {
  const [products, updateProducts] = useState([]);

  const parseAndUpdateProducts = collectionProducts => {
    const updatedProducts = collectionProducts.map((product, idx) => {
      const { id, src, altText } = product.images[0];
      const { price } = product.variants[0];

      return {
        id: product.id,
        title: product.title,
        price,
        image: {
          id,
          src,
          altText
        },
        onlineStoreUrl: product.onlineStoreUrl
      };
    });

    updateProducts(updatedProducts);
  };

  useEffect(() => {
    if (products.length > 0) {
      return;
    }

    const client = Client.buildClient({
      domain: 'alltrailspartner.myshopify.com',
      storefrontAccessToken: shopifyToken
    });

    client.collection.fetchWithProducts(shopifyCollectionId).then(collection => {
      parseAndUpdateProducts(collection.products);
    });
  }, []);

  const handleShopAllClick = () => {
    window.open('https://shop.alltrails.com', '_blank');
  };

  return (
    <div className={styles.container}>
      {products.length < 1 ? (
        <div className={styles.loadingSpinnerContainer}>
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <div className={styles.river}>
            <River title={GEAR_UP} useSlick slickSettings={slickSettings} titleClasses={styles.titleClass} className={styles.riverClass}>
              {products.map(product => {
                return <ShopifyCard {...product} />;
              })}
            </River>
          </div>
          <Button variant="primary" classes={styles.shopAll} onClick={handleShopAllClick}>
            {SHOP_ALL}
          </Button>
        </>
      )}
    </div>
  );
};

ShopifyPreview.propTypes = {
  shopifyToken: string.isRequired
};

export default ShopifyPreview;
